<div class="section-maintenance-container">
  <img [src]="section_maintenance.image" />
  <p>{{ section_maintenance.textLabel | translate }}</p>
  <p>{{ section_maintenance.textLabel2 | translate }}</p>
</div>
